export function injectJsonLd(id: string, data: object): void {
  removeJsonLd(id);
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = id;
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}

export function removeJsonLd(id: string): void {
  const el = document.getElementById(id);
  if (el) el.remove();
}